import router from '../../router'
import Vue from '@/main.js'

// 跳转页面
const toPage = (page,param)=>{
	router.push({
		path: '/'+page,
		query: param||{},
	},()=>{},()=>{})
}

// 返回上一页
const back = ()=>{
	// router.back()
	router.go(-1)
}

// 格式化
const formatDate = (d,hasTime)=>{
	let date = new Date(Number(d||0)*1000);
	let year = date.getFullYear();
	let month = date.getMonth()+1;
	let day = date.getDate();
	let hour = date.getHours();
	let minute = date.getMinutes();
	let second = date.getSeconds();
	
	month = ( month<10 ? '0'+month : month );
	day = ( day<10 ? '0'+day : day );
	hour = ( hour<10 ? '0'+hour : hour );
	minute = ( minute<10 ? '0'+minute : minute );
	second = ( second<10 ? '0'+second : second );
	
	return year+'-'+month+'-'+day+(hasTime==true?' '+hour+':'+minute+':'+second:'');
}

// 获取链接参数
const getUrlParam = (name)=>{
	let url = document.location.toString()
	let arrObj = url.split('?')
	if(arrObj.length>1){
		let arrPara = arrObj[1].split('&')
		let arr

		for(var i=0;i<arrPara.length;i++){
			arr = arrPara[i].split('=')

			if(arr!=null&&arr[0]==name){
				if(name=='type'){
					return arr[1].indexOf('#')>0?arr[1].split('#')[0]:arr[1]
				}else{
					return arr[1]
				}
			}
		}

		return ''
	}else{
		return ''
	}
}

// 富文本
const richIframe = process.env.WEBSITE_API.slice(0,-2)+'static/rich/rich-text.html'
const richIframeInit = (obj,content)=>{
	let iframe = obj.$refs.iframe
	iframe.contentDocument.getElementById('message').innerHTML = content
	obj.$nextTick(()=>{
		setTimeout(()=>{
			if(iframe && iframe.contentDocument && iframe.contentDocument.body){
				iframe.height = iframe.contentDocument.body.clientHeight
			}
		},200)
	})
}

// 动态更新页面地址
const rpurl = (pn)=>{
	let vr = Vue.$route
	let ph = Object.assign({},vr.query,pn||{})
	if(ph.page==1){
		delete ph.page
	}
	let pg = []
	for(let i in ph){
		pg.push(i+'='+ph[i])
	}
	window.history.replaceState('', '', '#'+vr.path+(pg.length>0?'?'+pg.join('&'):''))
}

// 获取数字最小单位(获取不到则为1)
const getMathMin = (num)=>{
	try{
		num = Number(num)
	}catch(e){
		return 1
	}
	if(typeof num!=='number'||num===0){
		return 1
	}
	
	let numString = num.toString()
	let decimalIndex = numString.indexOf('.')
	
	if(decimalIndex===-1){
		return 1
	}
	
	let decimalPart = numString.slice(decimalIndex+1)
	return Math.pow(10,-decimalPart.length)
}

// 加减乘除(浮点数)
const num_a = (arg1, arg2)=>{ // 加
	var r1, r2, m;
	try {
		r1 = arg1.toString().split(".")[1].length
	} catch (e) {
		r1 = 0
	}
	try {
		r2 = arg2.toString().split(".")[1].length
	} catch (e) {
		r2 = 0
	}
	m = Math.pow(10, Math.max(r1, r2));
	// return (arg1*m+arg2*m)/m;
	return (parseInt(arg1 * m) + parseInt(arg2 * m)) / m;
}
const num_s = (arg1, arg2)=>{ // 减
	var r1, r2, m;
	try {
		r1 = arg1.toString().split(".")[1].length
	} catch (e) {
		r1 = 0
	}
	try {
		r2 = arg2.toString().split(".")[1].length
	} catch (e) {
		r2 = 0
	}
	m = Math.pow(10, Math.max(r1, r2));
	// return (arg1*m-arg2*m)/m;
	return (parseInt(arg1 * m) - parseInt(arg2 * m)) / m;
}
const num_m = (arg1, arg2)=>{ // 乘
	var m = 0
	  , s1 = arg1.toString()
	  , s2 = arg2.toString();
	try {
		m += s1.split(".")[1].length
	} catch (e) {}
	try {
		m += s2.split(".")[1].length
	} catch (e) {}
	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
const num_c = (arg1, arg2)=>{ // 除
	var t1 = 0, t2 = 0, r1, r2;
	try {
		t1 = arg1.toString().split(".")[1].length
	} catch (e) {}
	try {
		t2 = arg2.toString().split(".")[1].length
	} catch (e) {}
	r1 = Number(arg1.toString().replace(".", ""));
	r2 = Number(arg2.toString().replace(".", ""));
	return (r1 / r2) * pow(10, t2 - t1);
}

export default {
	toPage,
	back,
	formatDate,
	getUrlParam,
	richIframe,
	richIframeInit,
	rpurl,
	getMathMin,
	num_a,
	num_s,
	num_m,
	num_c,
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js